"use strict";
// (C) 2021 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.BigChartDescriptor = void 0;
var tslib_1 = require("tslib");
var constants_1 = require("./constants");
var BaseChartDescriptor_1 = require("./baseChart/BaseChartDescriptor");
var BigChartDescriptor = /** @class */ (function (_super) {
    tslib_1.__extends(BigChartDescriptor, _super);
    function BigChartDescriptor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BigChartDescriptor.prototype.getSizeInfo = function (_insight, layoutDescriptor, settings) {
        return {
            width: {
                default: 6,
                min: 4,
                max: layoutDescriptor.gridColumnsCount,
            },
            height: {
                default: this.getDefaultHeight(settings.enableKDWidgetCustomHeight),
                min: this.getMinHeight(settings.enableKDWidgetCustomHeight),
                max: this.getMaxHeight(settings.enableKDWidgetCustomHeight),
            },
        };
    };
    BigChartDescriptor.prototype.getMinHeight = function (enableCustomHeight) {
        if (!enableCustomHeight) {
            return constants_1.DASHBOARD_LAYOUT_DEFAULT_VIS_HEIGHT;
        }
        return constants_1.MIDDLE_VISUALIZATION_HEIGHT;
    };
    return BigChartDescriptor;
}(BaseChartDescriptor_1.BaseChartDescriptor));
exports.BigChartDescriptor = BigChartDescriptor;
//# sourceMappingURL=BigChartDescriptor.js.map